module.exports = __webpack_public_path__ + "media/images/map_icons/Volleyball-1dfb0a4cf1ca74f0503aa291773b6330.svg";